import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const STORAGE_KEY = "puipi-theme-id";
const DEFAULT_THEME_ID = "yellow";

const themes = [
  {
    id: "yellow",
    label: "暖黃",
    vars: {
      "--app-bg": "#fffdf4",
      "--app-surface": "#fffefb",
      "--app-primary": "#f4c84d",
      "--app-primary-dark": "#e4b63c",
      "--app-accent": "#c99a20",
      "--app-text": "#4f4118",
      "--app-muted": "#6f5d2f",
      "--app-border": "#f0e2b7",
      "--app-focus": "#f7d971",
      "--app-soft-bg": "#fff5d7",
      "--app-card-gradient-end": "#fff5d8",
      "--app-badge-bg": "#fff2c1",
      "--app-badge-text": "#75580f",
      "--app-heading": "#5d470f",
      "--app-strong-text": "#6b5416",
      "--app-pill-bg": "#fff2c1",
      "--app-pill-text": "#75580f",
      "--app-surface-hover": "#fff8e5",
      "--app-status-online-bg": "#fff2c1",
      "--app-status-online-text": "#75580f",
      "--app-status-online-border": "#f0dc9d",
      "--app-status-pending-bg": "#fff9e6",
      "--app-status-pending-text": "#6e5b2a",
      "--app-status-pending-border": "#f1dfab",
      "--app-self-bubble": "#fff4cf",
      "--app-self-bubble-border": "#f1ddab",
      "--app-on-primary": "#3e3110",
      "--app-avatar-bg": "#fff2c1",
      "--app-avatar-text": "#75580f",
      "--app-overlay-bg": "rgba(43, 28, 0, 0.68)",
    },
  },
  {
    id: "mint",
    label: "薄荷",
    vars: {
      "--app-bg": "#f3fbf8",
      "--app-surface": "#ffffff",
      "--app-primary": "#4fc4a0",
      "--app-primary-dark": "#3aa886",
      "--app-accent": "#2f8f74",
      "--app-text": "#1f4a3f",
      "--app-muted": "#486f64",
      "--app-border": "#d0e9e1",
      "--app-focus": "#7adcc2",
      "--app-soft-bg": "#e9f7f2",
      "--app-card-gradient-end": "#f1faf6",
      "--app-badge-bg": "#e6f7f1",
      "--app-badge-text": "#1f6c56",
      "--app-heading": "#1f5f4d",
      "--app-strong-text": "#245e4c",
      "--app-pill-bg": "#e9f8f2",
      "--app-pill-text": "#1f6c56",
      "--app-surface-hover": "#f3fbf8",
      "--app-status-online-bg": "#dbf9ec",
      "--app-status-online-text": "#145a3e",
      "--app-status-online-border": "#b9ecd5",
      "--app-status-pending-bg": "#effaf5",
      "--app-status-pending-text": "#3f665a",
      "--app-status-pending-border": "#cde7de",
      "--app-self-bubble": "#dff4ec",
      "--app-self-bubble-border": "#b8e3d5",
      "--app-on-primary": "#12352b",
      "--app-avatar-bg": "#dff5ed",
      "--app-avatar-text": "#1f6c56",
      "--app-overlay-bg": "rgba(11, 30, 24, 0.7)",
    },
  },
  {
    id: "sky",
    label: "天空",
    vars: {
      "--app-bg": "#f4f9ff",
      "--app-surface": "#ffffff",
      "--app-primary": "#5fa8ff",
      "--app-primary-dark": "#4a91e8",
      "--app-accent": "#2f6fae",
      "--app-text": "#1d4265",
      "--app-muted": "#4f6c8c",
      "--app-border": "#d4e7fb",
      "--app-focus": "#8ec5ff",
      "--app-soft-bg": "#eaf4ff",
      "--app-card-gradient-end": "#edf6ff",
      "--app-badge-bg": "#e7f2ff",
      "--app-badge-text": "#23598f",
      "--app-heading": "#235381",
      "--app-strong-text": "#2b608f",
      "--app-pill-bg": "#e7f2ff",
      "--app-pill-text": "#23598f",
      "--app-surface-hover": "#f3f9ff",
      "--app-status-online-bg": "#e6f2ff",
      "--app-status-online-text": "#23598f",
      "--app-status-online-border": "#cddff7",
      "--app-status-pending-bg": "#f2f8ff",
      "--app-status-pending-text": "#4d6a88",
      "--app-status-pending-border": "#d9e7f7",
      "--app-self-bubble": "#eaf4ff",
      "--app-self-bubble-border": "#c8dcf4",
      "--app-on-primary": "#17385a",
      "--app-avatar-bg": "#e6f2ff",
      "--app-avatar-text": "#23598f",
      "--app-overlay-bg": "rgba(12, 26, 48, 0.72)",
    },
  },
  {
    id: "lavender",
    label: "薰衣草",
    vars: {
      "--app-bg": "#faf7ff",
      "--app-surface": "#ffffff",
      "--app-primary": "#b48ef5",
      "--app-primary-dark": "#9f78e6",
      "--app-accent": "#7c57b2",
      "--app-text": "#43325f",
      "--app-muted": "#66557f",
      "--app-border": "#e5dcf7",
      "--app-focus": "#c3a7f8",
      "--app-soft-bg": "#f2ecfd",
      "--app-card-gradient-end": "#f4efff",
      "--app-badge-bg": "#f1eaff",
      "--app-badge-text": "#67469e",
      "--app-heading": "#5d3f95",
      "--app-strong-text": "#6846a3",
      "--app-pill-bg": "#f1eaff",
      "--app-pill-text": "#67469e",
      "--app-surface-hover": "#f8f3ff",
      "--app-status-online-bg": "#efe7ff",
      "--app-status-online-text": "#67469e",
      "--app-status-online-border": "#dccdf5",
      "--app-status-pending-bg": "#f8f4ff",
      "--app-status-pending-text": "#6f5e8b",
      "--app-status-pending-border": "#e8def8",
      "--app-self-bubble": "#f1eaff",
      "--app-self-bubble-border": "#dbcdf6",
      "--app-on-primary": "#35245a",
      "--app-avatar-bg": "#efe7ff",
      "--app-avatar-text": "#67469e",
      "--app-overlay-bg": "rgba(31, 20, 53, 0.72)",
    },
  },
  {
    id: "peach",
    label: "蜜桃",
    vars: {
      "--app-bg": "#fff8f3",
      "--app-surface": "#ffffff",
      "--app-primary": "#ffb16a",
      "--app-primary-dark": "#f09c52",
      "--app-accent": "#b66b2f",
      "--app-text": "#633e20",
      "--app-muted": "#7f5e43",
      "--app-border": "#f6ddcb",
      "--app-focus": "#ffc489",
      "--app-soft-bg": "#fff0e4",
      "--app-card-gradient-end": "#fff2e6",
      "--app-badge-bg": "#ffe9d7",
      "--app-badge-text": "#9b531f",
      "--app-heading": "#8d4a1a",
      "--app-strong-text": "#9a5626",
      "--app-pill-bg": "#ffe9d7",
      "--app-pill-text": "#9b531f",
      "--app-surface-hover": "#fff5ed",
      "--app-status-online-bg": "#ffe9d7",
      "--app-status-online-text": "#9b531f",
      "--app-status-online-border": "#f3d4be",
      "--app-status-pending-bg": "#fff4eb",
      "--app-status-pending-text": "#866349",
      "--app-status-pending-border": "#f5dece",
      "--app-self-bubble": "#ffefdf",
      "--app-self-bubble-border": "#f3d9c3",
      "--app-on-primary": "#4d2b0f",
      "--app-avatar-bg": "#ffe9d7",
      "--app-avatar-text": "#9b531f",
      "--app-overlay-bg": "rgba(48, 26, 10, 0.7)",
    },
  },
  {
    id: "coral",
    label: "珊瑚",
    vars: {
      "--app-bg": "#fff6f5",
      "--app-surface": "#ffffff",
      "--app-primary": "#ff8f87",
      "--app-primary-dark": "#ed786f",
      "--app-accent": "#b84a43",
      "--app-text": "#5f312d",
      "--app-muted": "#7f5651",
      "--app-border": "#f7d8d5",
      "--app-focus": "#ffaea8",
      "--app-soft-bg": "#ffecea",
      "--app-card-gradient-end": "#fff0ee",
      "--app-badge-bg": "#ffe9e7",
      "--app-badge-text": "#993a34",
      "--app-heading": "#8d3530",
      "--app-strong-text": "#973f39",
      "--app-pill-bg": "#ffe9e7",
      "--app-pill-text": "#993a34",
      "--app-surface-hover": "#fff3f2",
      "--app-status-online-bg": "#ffe9e7",
      "--app-status-online-text": "#993a34",
      "--app-status-online-border": "#f3ccc8",
      "--app-status-pending-bg": "#fff5f4",
      "--app-status-pending-text": "#855d58",
      "--app-status-pending-border": "#f6dbd8",
      "--app-self-bubble": "#ffe9e7",
      "--app-self-bubble-border": "#f3ccc8",
      "--app-on-primary": "#4d1a17",
      "--app-avatar-bg": "#ffe9e7",
      "--app-avatar-text": "#993a34",
      "--app-overlay-bg": "rgba(53, 20, 17, 0.72)",
    },
  },
  {
    id: "rose",
    label: "玫瑰",
    vars: {
      "--app-bg": "#fff6fb",
      "--app-surface": "#ffffff",
      "--app-primary": "#e983bf",
      "--app-primary-dark": "#d46ba8",
      "--app-accent": "#b24a82",
      "--app-text": "#5f2d49",
      "--app-muted": "#7d5370",
      "--app-border": "#f4d8e8",
      "--app-focus": "#f1a8d3",
      "--app-soft-bg": "#fdebf5",
      "--app-card-gradient-end": "#fff0f7",
      "--app-badge-bg": "#fde7f2",
      "--app-badge-text": "#963a6d",
      "--app-heading": "#873364",
      "--app-strong-text": "#923b6d",
      "--app-pill-bg": "#fde7f2",
      "--app-pill-text": "#963a6d",
      "--app-surface-hover": "#fff3f9",
      "--app-status-online-bg": "#fde7f2",
      "--app-status-online-text": "#963a6d",
      "--app-status-online-border": "#f0cde1",
      "--app-status-pending-bg": "#fff4fa",
      "--app-status-pending-text": "#825a73",
      "--app-status-pending-border": "#f4dbeb",
      "--app-self-bubble": "#fde7f2",
      "--app-self-bubble-border": "#f0cde1",
      "--app-on-primary": "#4b1834",
      "--app-avatar-bg": "#fde7f2",
      "--app-avatar-text": "#963a6d",
      "--app-overlay-bg": "rgba(52, 18, 37, 0.72)",
    },
  },
];

const ThemeContext = createContext(null);

const applyThemeVars = (vars) => {
  const root = document.documentElement;
  Object.entries(vars).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });
};

export const ThemeProvider = ({ children }) => {
  const [themeId, setThemeId] = useState(DEFAULT_THEME_ID);

  useEffect(() => {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved && themes.some((theme) => theme.id === saved)) {
      setThemeId(saved);
    }
  }, []);

  useEffect(() => {
    const currentTheme = themes.find((theme) => theme.id === themeId) || themes[0];
    applyThemeVars(currentTheme.vars);
    window.localStorage.setItem(STORAGE_KEY, currentTheme.id);
  }, [themeId]);

  const value = useMemo(
    () => ({
      themes,
      themeId,
      setThemeId,
    }),
    [themeId]
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within ThemeProvider");
  }
  return context;
};

export { themes, DEFAULT_THEME_ID };
